import React from 'react'
import { Main } from '../components/InterHostelPage/Main'

const InterHostel = () => {
  return (
    <div>
        <Main/>
    </div>
  )
}

export default InterHostel